module.exports = __webpack_public_path__ + "img/c.931c3cb9.png";